import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { useDevToolsProtection } from './hooks/useDevToolsProtection';
import SecurityWrapper from './components/SecurityWrapper/SecurityWrapper';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeAuth } from './redux/action/actions';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

function App() {
    const dispatch = useDispatch();
    const { isInitialized } = useSelector(state => state.auth);
    const [showMinimumLoading, setShowMinimumLoading] = useState(true);
    
    // Enable DevTools protection
    useDevToolsProtection();
    
    // Initialize authentication state from localStorage on app start
    useEffect(() => {
        // Initialize auth immediately without artificial delay
        dispatch(initializeAuth());
        
        // Show loading for minimum 300ms for better UX (avoid flash)
        const minLoadingTimer = setTimeout(() => {
            setShowMinimumLoading(false);
        }, 300);
        
        return () => clearTimeout(minLoadingTimer);
    }, [dispatch]);

    // Show loading screen only when actually needed
    const shouldShowLoading = !isInitialized || showMinimumLoading;

    if (shouldShowLoading) {
        return <LoadingScreen message="Initializing secure connection..." />;
    }
    
    return (
        <SecurityWrapper>
            <RouterProvider router={router} />
        </SecurityWrapper>
    );
}

export default App;